import React from 'react';
import Datatable from '../../../../components/molecules/datatable';
import { TableColumns } from '../../configuration';
import * as PaymentSelectors from 'redux/reducers/payment_list_reducer/selectors';
import { useDispatch } from 'react-redux';
import PaymentActions from 'redux/reducers/payment_list_reducer/actions';
import useStyles from './styles';
import { Box } from '@material-ui/core';
import Filter from '../filter';
import useQuery from 'custom_hooks/useQuery';
import * as AuthSelectors from '../../../../redux/reducers/gl_auth_reducer/selectors';
import { AuthRoles } from 'config';

export default function DatatableList() {
  const ROLE = AuthSelectors.useSelectUserRole();
  const result = PaymentSelectors.useGetPaymentInfoList();
  const paging = result.data?.paging;
  const dispatch = useDispatch();
  const sortField = React.useRef<string>(TableColumns[0].id);
  const sortType = React.useRef<'asc' | 'desc'>('desc');
  const classes = useStyles();

  const query = useQuery();
  const paymentRef = query.get('paymentRef');
  const schemeType = query.get('schemeType');
  const msconCountry = query.get('msconCountry');
  let searchParams = {
    ...(paymentRef && { paymentRef }),
    ...(schemeType && { schemeType }),
    ...(msconCountry && { msconCountry }),
  };

  return (
    <Box display="flex" flexDirection="column">
      {(ROLE === AuthRoles.Agent || ROLE === AuthRoles.Admin) && (
        <Filter
          paymentRef={paymentRef}
          schemeType={schemeType}
          msconCountry={msconCountry}
          role={ROLE}
        />
      )}

      <Datatable
        loading={true}
        sorting={{
          sortField: sortField.current,
          order: sortType.current,
        }}
        paging={paging}
        data={result.data?.items || []}
        columns={TableColumns}
        changePageHandle={(selectedPage, pageSize, order, _sortField) => {
          sortType.current = order;
          sortField.current = _sortField;
          dispatch(
            PaymentActions.fetchPaymentInfoAction({
              sortField: _sortField,
              page: selectedPage,
              pageSize: pageSize,
              order: order,
              ...searchParams,
            })
          );
        }}
      />
    </Box>
  );
}
